import { useMemo } from 'react';
import { Skeleton } from '@material-ui/lab';
import { Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import useGetAssignmentProgressGraphQuery from 'features/realplays/services/queries/useGetAssigmentProgressGraphData';
import classes from './ReportResult.module.css';

const ImprovementGraph = ({ assignment_uuid, response_uuid, mode, overall }) => {
  const { data: dataGraph, isLoading: isLoadingGraph } = useGetAssignmentProgressGraphQuery({
    assignment_uuid,
    response_uuid,
    mode,
  });

  const graphLength = useMemo(() => dataGraph?.length, [dataGraph?.length]);

  const labels = useMemo(() => {
    if (!dataGraph || dataGraph?.length === 0) return [];
    return mode === 'review'
      ? [...dataGraph?.map((item) => item?.reviewed_at), 'Most Recent']
      : dataGraph?.map((item) => item?.reviewed_at);
  }, [dataGraph, mode]);

  const dataNumbers = useMemo(() => {
    if (!dataGraph || dataGraph?.length === 0) return [];
    return mode === 'review'
      ? [...dataGraph?.map((item) => item?.scenario_response?.average_stars), overall]
      : dataGraph?.map((item) => item?.scenario_response?.average_stars);
  }, [dataGraph, mode, overall]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      datalabels: {
        display: true,
        align: 'top',
        color: '#455a64',
        font: {
          weight: 400,
        },
        formatter: (value) => value,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          display: false,
          stepSize: 1,
        },
        grace: '5%',
      },
      x: {
        offset: true,
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        data: dataNumbers,
        borderColor: 'rgba(4, 148, 253, 1)',
        backgroundColor: 'rgba(4, 148, 253, 0.2)',
        borderWidth: 1.7,
        pointRadius: 5,
        pointHoverRadius: 7,
      },
    ],
  };

  return isLoadingGraph ? (
    <Skeleton variant="rect" width="100%" height="10vh" style={{ borderRadius: '0.5rem' }} />
  ) : mode === 'review' ? (
    graphLength > 1 ? (
      <div>
        <div className={classes.graphContainer}>
          <h4>🚀 Improvement</h4>
          <Line options={options} data={data} plugins={[ChartDataLabels]} />
        </div>
      </div>
    ) : (
      <div>
        <div className={classes.graphContainer}>
          <h4>🚀 Improvement</h4>
          <div className={classes.emptyState}>
            <div>
              Keep track! After the assigned user completes Two more reps, you’ll unlock a new
              visualization of their efforts.
            </div>
          </div>
        </div>
      </div>
    )
  ) : graphLength === 3 ? (
    <div>
      <div className={classes.graphContainer}>
        <h4>🚀 Improvement</h4>
        <Line options={options} data={data} plugins={[ChartDataLabels]} />
      </div>
    </div>
  ) : (
    <div>
      <div className={classes.graphContainer}>
        <h4>🚀 Improvement</h4>
        <div className={classes.emptyState}>
          <div>You’re leveling up! Two more reps and your progress graph will light up.</div>
        </div>
      </div>
    </div>
  );
};

export default ImprovementGraph;
